export default {
    state: {
        isCollapse:false,
        currentMenu: null,
        tabsList: [
            {
                path: '/home',
                name: '首页',
                icon: 'home'
            }
        ]
    },
    mutations: {
        collapseMenu(state) {
            state.isCollapse = !state.isCollapse
        },
        selectMenu(state, val) {
            if (val.name === 'home') {
                state.currentMenu = null
            } else {
                state.currentMenu = val
                let result = state.tabsList.findIndex(item => item.name === val.name)
                result === -1 ? state.tabsList.push(val) : ''
            }
        },
        closeTab(state, val) {
            let result = state.tabsList.findIndex(item => item.name === val.name)
            state.tabsList.splice(result, 1)
        },
        clearTags(state) {
            state.currentMenu =null
            state.tagsList =[]
        },
    },
    actions: {}
}



// WEBPACK FOOTER //
// ./src/store/tab.js